import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'upload',
  templateUrl: './upload.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryUploadComponent implements OnInit {
  @Output() moveNextPreviousEvent = new EventEmitter<any>();
  @Input() data;
  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {}
  parentFun(event: any) {
    this.moveNextPreviousEvent.next({ status: event, id: this.data.id });
  }
  individualLocationNextStep(event) {
    this.parentFun(event?.transaction_status ? event.transaction_status : 'forward');
  }
}
